import { render, staticRenderFns } from "./AppMobileMenu.vue?vue&type=template&id=05d20d78"
import script from "./AppMobileMenu.vue?vue&type=script&lang=js"
export * from "./AppMobileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports